<template>
  <div>
    <van-sticky>
      <!-- 排序 -->
      <sortbar-vue :source="navData" @click-event="navChange" :filterButtondata="filterButtondata" :zunxiangData="zunxiangData"></sortbar-vue>
    </van-sticky>
    <van-popup v-model="navData.showSearchPanel" position="right" :style="{ width:'80%',height:'100%' }" :overlay-style="{backgroundColor: 'rgba(0,0,0,.6)'}">
      <!-- 搜索弹窗 -->
      <product-filter-vue ref="childComponent" @addressAdd="addressAdd" :filter-obj="filterObj" @change-event="changeSearchParams"></product-filter-vue>
    </van-popup>
    <van-list v-model="ajaxInfo.loading" :finished="ajaxInfo.finished" finished-text="没有更多了" @load="loadMore">
      <div :class="navData.direction== 'horizontal' ? 'goods-list' : 'goods-grid'">
        <template v-for="(goods, i) in goodsList">
          <template v-if="i==4&&adInfo.keyWordBanner&&adInfo.keyWordBanner.items">
            <ad-swipe-vue :data-source="adInfo.keyWordBanner" :key="i" swiper-class="keyword-swiper"></ad-swipe-vue>
          </template>
          <template v-else-if="i==18&&adInfo.goodsBanner&&adInfo.goodsBanner.items">
            <ad-swipe-vue :data-source="adInfo.goodsBanner" :key="i" swiper-class="goods-swiper"></ad-swipe-vue>
          </template>
          <template v-else-if="i==28&&adInfo.identityBanner&&adInfo.identityBanner.items">
            <ad-swipe-vue :data-source="adInfo.identityBanner" :key="i" swiper-class="identity-swiper"></ad-swipe-vue>
          </template>

          <template>
            <!-- 商品列表 -->
            <div class="goods-box live-good-logo" :id="goods.id" :key="goods.id+i" :class="goods.type == 2 ? 'is-bannel' : ''">
              <div class="goods-detail" @touchstart="gotouchstart(goods, i)" @touchmove="gotouchmove(goods, i)" @touchend="gotouchend(goods, i)" @click="jumpDetail(goods, i)" v-if="goods.type != 2" :class="goods.activityImg && navData.direction!= 'horizontal' ? 'is-active' : ''">
                <div class="goods-img" :class="goods.activityImg && navData.direction== 'horizontal' ? 'is-active' : ''">
                  <div class="vipTag" v-if="!goods.vipFlag"></div>                
                  <div class="live-good-logo-in" style="right: 4px; top: 4px; width: unset" v-if="goods.productStatusResp && goods.productStatusResp.isShow">
                    <img style="width: 16px; height: 16px; display: block" src="../../../assets/images/3.gif" alt="" />
                  </div>
                  <img :src="goods.fileNameDefault" @error="nofind_pic()" class="goods-default"/>
                  <!-- <img src="//image01.homedo.com/Files/Images/cms/www/20230524/5242875445648531303_pic1.png" class="goods-seven" /> -->
                  <img v-if="goods.isPresell" src="../../../assets/images/search-page-presale.png" class="goods-pre" />
                  <img v-if="goods.activityImg" :src="goods.activityImg" class="goods-active" style="width: 6rem; height: 2rem" />
                  <span class="is-ad" v-if="goods.isAd">推荐</span>
                  <div class="text-swiper" v-if="goods.huopinInfo && goods.huopinInfo.length>0">
                    <pintuan-vue :data-source="goods.huopinInfo" :class-name="'pintuan-'+goods.id+i"></pintuan-vue>
                    <!-- <div class="huopin-info" :class="goods.huopinInfo.length>1?'is-swiper':''" v-for="(info,i) in goods.huopinInfo" :key="i">{{info.userName}}发起拼团</div> -->
                  </div>

                </div>
                <div class="goods-content">
                  <div style="height:8.3rem">
                    <div :class="[viewHistory[goods.id] ? 'buy-title': '','goods-title']">
                      {{ goods.name }}
                    </div>
                    <div v-if="goods.shopName" class="goods-shop">
                      <span class="img-icon"></span>
                      <span style="flex:1">{{ goods.shopName + ' >'}}</span>
                    </div>
                    <div v-if="!goods.shopName && goods.saleProperties && goods.saleProperties.length" class="proper-type">
                      <span v-for="(item,index) in goods.saleProperties" :key="index" class="proper-item">{{item}}</span>
                    </div>
                    <div class="tag-list">

                      <div v-if="goods.tagList && goods.tagList.length" class="tag-content">
                        <div v-for="(child, idx) in goods.tagList" :key="idx" :class="[child.tagValue == '自营' ? 'zy' : '','tag-item']">{{child.tagValue}}</div>
                      </div>
                    </div>
                  </div>

                  <div class="goods-price">
                    <span style="margin-right: 1rem"><em class="price-icon">￥</em>{{ goods.proPrice&&goods.proPrice > 0 ? goods.proPrice : "面议" }} <span v-if="goods.savePrice" style="background: #FFF2F2;font-size:1rem" class="p-2 p-l-4 p-r-4"><i class="hmd-icon-lightning"></i>立省{{goods.savePrice}}元</span></span>

                    <em class="shopping-card" v-if="(goods.purchaseOrder&&!goods.isPresell && goods.productSource == 1 && goods.proPrice > 0) && navData.direction == 'horizontal'" @click.stop="addToCard(goods, i)"></em>

                  </div>
                  <div class="goods-sale">
                    <div>
                      <span class="goods-num">已售{{ goods.turnover }}{{ goods.proUnit }}</span>
                      <span class="goods-num grid-hidden">{{ goods.orderMinCount }}{{ goods.proUnit }}起订</span>
                    </div>
                    <em class="shopping-card" v-if="(!goods.isPresell && goods.productSource == 1 && goods.proPrice > 0) && navData.direction != 'horizontal'" @click.stop="addToCard(goods, i)"></em>
                  </div>
                </div>
              </div>
              <div class="goods-pop" v-if="goods.type != 2" v-show="showPopId == goods.lowestPid" @click="showPopId = ''">
                <div class="attention" @click.stop="toAttention">
                  <span class="pop-icon"></span><span>关注</span>
                </div>
                <div class="bargain" v-if="goods.productSource == 1" @click.stop="toBargain">
                  <span class="pop-icon"></span><span>议价</span>
                </div>
                <div class="similar" @click.stop="toSimilar(goods)">
                  <span class="pop-icon"></span><span>找相似</span>
                </div>
              </div>
              <div v-if="goods.bannerList.length && goods.bannerList[0].items.length" class="banner">
                <swiper :options="getBannerSwipe(goods)">
                  <swiper-slide v-for="item in goods.bannerList[0].items" :key="item.picUrl">
                    <a :href="item.linkUrl"><img style="height: 10.4rem; width: 100%" :src="item.picUrl" /></a>
                  </swiper-slide>
                </swiper>
              </div>
            </div>
          </template>
        </template>
      </div>
    </van-list>

    <div class="fullscreen">
      <AddressSelection @selectedregion="getCity" :showRegionPop.sync="showRegion" :selectInitData="selectInitData"></AddressSelection>
      <switchingAddress ref="address" @selectedregions="getCitys" @showsiteadd="showSiteAdd" :showSite.sync="popupVisible"></switchingAddress>
    </div>

  </div>
</template>
<script>
import Vue from 'vue'
Vue.use(geoRegion)
let vm = null
import sortbarVue from './sortbar.vue'
import productFilterVue from './productFilter.vue'
import { getBffSearch, getProductPriceAsyncM, addShopCart, getSearchSpecial, getKeywordMatch, queryProductGroupList,getSearchFilterButton } from '../../../request/search'
import { mixin } from '../mixin'
import adSwipeVue from '../../../components/adSwiper/adSwipe.vue'
import pintuanVue from './pintuan.vue'
export default {
  components: {
    sortbarVue,
    productFilterVue,
    adSwipeVue,
    pintuanVue,
  },
  mixins: [mixin()],
  data() {
    return {
      popupVisible: false, // 显示用户设置地址
      showRegion: false, // 地址选择开关
      selectInitData:[],
      goodsList: [],
      viewHistory: {},
      showPopId: '',
      searchPannelInfo: {
        listMap: [],
        searchActivityTagReq: null,
        filterDetail: '',
      },
      adInfo: {},
      // isZunXiang:false, // 按钮是否显示
      filterButtondata: {},
      zunxiangData:{}
    }
  },
  created() {
    vm = this
    function convertToObjectArray(obj) {
        var result = []
        var provinceObject = {
          name: 'provinceId',
          id: obj.provinceId,
          text: obj.provinceName
        }
        result.push(provinceObject)
        var cityObject = {
          name: 'cityId',
          id: obj.cityId,
          text: obj.cityName
        }
        result.push(cityObject)
        return result
    }
    var newArray = convertToObjectArray($HMD$.globalCity)
    vm.selectInitData = newArray
  },
  mounted() {
    vm = this
    vm.keywordMatching()
    vm.getZXdata()
  },
  methods: {
    getCitys (i) {
      vm.$refs.childComponent.childMethod(i);
      vm.selectInitData = [
        { name: 'provinceId', id: i.provinceId , text: i.provinceName },
        { name: 'cityId', id: i.cityId, text: i.cityName }
      ]
      $HMD$.setRemoteCity({
        'address': i.address,
        'addressId': i.id,
        'locatedCity': i.cityName,
        'cityId': i.cityId,
        'cityName': i.cityName,
        'provinceId': i.provinceId,
        'provinceName': i.provinceName
      })
    },
    getCity(arr) {
      vm.$refs.childComponent.childMethod(arr);
      vm.selectInitData = arr
      $HMD$.setRemoteCity({
        'address': '',
        'addressId': '0',
        'locatedCity': arr[1].text,
        'cityId': arr[1].id,
        'cityName': arr[1].text,
        'provinceId': arr[0].id,
        'provinceName': arr[0].text
      })
    },
    addressAdd() {
      vm.$refs.address.postMemberAddress().then(res => {
        res.length <= 0 ? vm.showRegion = true : vm.popupVisible = true
      })
    },
    showSiteAdd (){
      vm.popupVisible = false
      vm.showRegion = true
    },

    getDataList() {      
      if (this.pageData.page == 1) {
        this.ajaxInfo.finished = false
      }
      let param = {
        keyword: this.filterObj.keyword,
        categoryId: this.filterObj.categoryId,
        categoryLevel: this.filterObj.categoryLevel,
        brandId: this.filterObj.brandId,
        promotionId: this.filterObj.promotionId,
        productSource:this.filterObj.productSource,
        page: this.pageData.page,
        pageSize: this.pageData.size,
        sortBy: this.navData.sortBy,
        listMap: this.searchPannelInfo.listMap,
        showSubProduct: this.filterObj.showSubProduct,
        isCustom: '',
        selectType: 2,
        searchType: '1',
        searchActivityTagReq:this.pageData.searchActivityTagReq,
        isYearProduct:this.pageData.isYearProduct
      }
      if (this.searchPannelInfo.searchActivityTagReq && this.searchPannelInfo.searchActivityTagReq.tagIdList.length > 0) {
        param['searchActivityTagReq'] = this.searchPannelInfo.searchActivityTagReq
      }
      if (this.filterObj.properties && this.filterObj.properties.length) {
        param.properties = this.filterObj.properties
      }
      getBffSearch(param).then((res) => {
        this.ajaxInfo.loading = false
        const { data, respCode } = res.data
        if (data && respCode == '0000') {
          const pageData = data
          if (pageData) {
            if (pageData.pid) {
              let url = pageData.linkUrl || this.getProLink({ productSource: pageData.pidType, lowestPid: pageData.pid })
              if (url) {
                location.href = url
                return
              }
            }
            if (this.pageData.page == 1 && pageData.useNoResultFillQuery != 0) {
              //跳转无数据页面
              setTimeout(function () {
                location.href = `${$HMD$.rApi.M}/h5new/search/empty`
              }, 500)
              //无自然搜索商品结果埋点
              this.yiGuanSearch('null_natural_search_result_display')
              return false
            }
            // console.log(this.pageData.tagIds)
           
            // if(this.pageData.tagIds &&pageData.total == 0){              
            //     //跳转无数据页面
            //     setTimeout(function () {
            //         location.href = `${$HMD$.rApi.M}/h5new/search/empty`
            //     }, 500)
            //     //无自然搜索商品结果埋点
            //     this.yiGuanSearch('null_natural_search_result_display')
            //     return false
            // }
            if (!pageData.productInfoList || pageData.productInfoList.length < this.pageData.size) {
              //无更多数据
              this.ajaxInfo.finished = true             
            }
            if (pageData.productInfoList && pageData.productInfoList.length > 0) {
              this.getGoodsPrice(pageData.priceAsyncList)
              this.queryProductGroupList(pageData.bizExtend.partnerProductIds.join())
              const list = pageData.productInfoList.map((item) => {
                return Object.assign(item, {
                  proPrice: '',
                  proUnit: '',
                  activityImg: '',
                  huopinInfo: null,
                  vipFlag:true
                })
              })
              if (pageData.page == 1) {
                this.goodsList = list
                this.getSearchSpecial(pageData.bizExtend)
              } else {
                this.goodsList = this.goodsList.concat(list)
              }
              this.pageData.page = pageData.page + 1
              this.yiGuanSearch('natural_search_result_display', pageData.total)
            } else if (pageData.page == 1 && pageData.total == 0 && pageData.useNoResultFillQuery == 0) {
              this.goodsList = []
              this.yiGuanSearch('null_natural_search_result_display')
            }
          }
        }
      })
    },
    //商品价格
    getGoodsPrice(params) {
      getProductPriceAsyncM({
        priceAsyncList: params,
      }).then((res) => {
        const { data, respCode } = res.data
        if (data && respCode == '0000') {
          let priceMap = {}
          data.forEach((price) => {
            priceMap[price.pid] = price
          })

          vm.goodsList.forEach((goods) => {
            if (priceMap[goods.id]) {
              if (priceMap[goods.id].reductionTag) {
                goods.tagList.push({ type: 8, tagValue: priceMap[goods.id].reductionTag })
              }
              if (priceMap[goods.id].activityTextTag && goods.productSource == 1) {
                goods.tagList.push({ type: 9, tagValue: priceMap[goods.id].activityTextTag })
              }
              goods.proPrice = priceMap[goods.id].goodsPrice
              goods.proUnit = priceMap[goods.id].unit
              goods.activityImg = priceMap[goods.id].activityImgUrl
              goods.productStatusResp = priceMap[goods.id].productStatusResp
              goods.savePrice = priceMap[goods.id].savePrice
              goods.lowestPid = priceMap[goods.id].lowestPid || priceMap[goods.id].pid
              goods.orderMinCount = priceMap[goods.id].orderMinCount
              goods.vipFlag = priceMap[goods.id].vipFlag
            }
          })
        }
      })
    },
    //获取商品拼团信息
    queryProductGroupList(ids) {
      if (ids) {
        queryProductGroupList({ productIdList: ids }).then((res) => {
          const { data, respCode } = res.data
          if (data && respCode == '0000') {
            let huopinMap = {}
            data.forEach((item) => {
              huopinMap[item.productId] = item.list
            })
            vm.goodsList.forEach((goods) => {
              if (huopinMap[goods.id]) {
                goods.huopinInfo = huopinMap[goods.id]
              }
            })
          }
        })
      }
    },
    //  获取广告信息
    getSearchSpecial(params) {
      getSearchSpecial({
        ...params,
        categoryId: this.filterObj.categoryId || 0,
        keyWord: this.filterObj.keyword || '',
      }).then((res) => {
        let { data, respCode } = res.data
        if (respCode == '0000') {
          this.$set(this.adInfo, 'goodsBanner', data.goodsBanner[0] || null)
          this.$set(this.adInfo, 'identityBanner', data.identityBanner[0] || null)
          this.$set(this.adInfo, 'keyWordBanner', data.keyWordBanner[0] || null)
        }
      })
    },
    //关键词匹配跳转
    keywordMatching() {
      if (this.filterObj.keyword) {
        getKeywordMatch(this.filterObj.keyword || '').then((res) => {
          if (res.data.respCode == '0000' && res.data.data) {
            var mobileLink = res.data.data.mobileLink || ''
            if (!!mobileLink) {
              window.location.href = mobileLink
              return
            }
          }
        })
      }
    },
    //跳商详页
    jumpDetail(goods, index) {
      const linkUrl = vm.getProLink(goods)
      vm.countClickGoods(goods, index, false)

      $HMD$.aYiGuan('btn_click', null, {
          $url: window.location.href,
          $title: document.title,
          desc:'搜索列表',
          type:'商品图片',
          link_page_url:linkUrl,
          platform:$HMD$.rNavigator
        })

      if ($HMD$.rNavigator == 'ios' || $HMD$.rNavigator == 'android') {
        if (goods.productSource == 1) {
          $HMD$.M.sendApp({
            name: 'good',
            value: goods.lowestPid,
            promtionID: '',
          })
        } else {
          $HMD$.M.sendApp({
            name: 'browser',
            value: linkUrl,
            title: '联营商品详情',
            hideClose: true,
          })
        }
      } else {
        location.href = linkUrl
      }
      vm.showPopId = ''
      vm.viewHistory[goods.id] = true
      vm.viewHistory['goodsDirection'] = vm.navData.direction
      sessionStorage.setItem('viewProductHistory', JSON.stringify(vm.viewHistory))
    },
    getProLink(goods) {
      return goods.productSource == 1 ? `${$HMD$.rApi.mGoodsDetail}?p=${goods.lowestPid}` : goods.productSource == 2 ? `${$HMD$.rApi.mGoodsDetailS}?itemId=${goods.lowestPid}` : ''
    },
    gotouchstart(good, i) {
      clearTimeout(this.timeOutEvent)
      this.timeOutEvent = 0
      this.timeOutEvent = setTimeout(() => {
        //执行长按要执行的内容，
        this.showPopId = good.id
      }, 500)
    },
    //手释放
    gotouchend() {
      clearTimeout(this.timeOutEvent)
      if (this.timeOutEvent != 0) {
        // this.jumpDetail()
      }
    },
    //如果手指有移动，则取消所有事件
    gotouchmove() {
      clearTimeout(this.timeOutEvent)
      this.timeOutEvent = 0
      this.showPopId = ''
    },
    //关注
    toAttention() {
      if (!$HMD$.Cookie('accountId')) {
        window.location.href = $HMD$.rApi['M'] + '/Account/Login?url=' + window.location.href
        return false
      }
      let params = {
        operatorId: $HMD$.Cookie('accountId'),
        productId: this.showPopId,
      }
      $HMD$.Ajax({
        url: $HMD$.rApi.bffCommon + '/bff-common-api/productDetail/addtMemberAttention',
        type: 'POST',
        crossDomain: true,
        data: JSON.stringify(params),
        dataType: 'json',
        contentType: 'application/json',
        success: function (res) {
          if (res.respCode == '0000') {
            $HMD$.Prop('成功加入，可以在我的关注中找到')
            vm.showPopId = ''
          }
        },
        error: function (err) {},
      })
      vm.yiGuanGoodsClick('关注')
    },
    //议价
    toBargain() {
      $HMD$.M.lineXN()
      vm.yiGuanGoodsClick('议价')
      this.showPopId = ''
    },
    //找相似
    toSimilar(good) {
      this.filterObj.categoryId = good.categoryId3
      this.filterObj.categoryLevel = 3
      vm.pageData.page = 1
      this.getDataList()
      vm.yiGuanGoodsClick('找相似')
      document.documentElement.scrollTop = 0
      this.showPopId = ''
    },
    countClickGoods(goods, index, isAdd) {
      const params = {
        type: '搜索',
        content_type: '商品',
        is_filter: false,
        btn_name: isAdd ? '加进货单' : '',
        sku_rank: index + 1,
        is_ad_sku: goods.isAd ? true : false,
        item_id: goods.mainPid,
        item_name: goods.name,
        item_type: goods.productSource + '',
        item_specific_module: goods.model,
        first_category_id: goods.categoryId1,
        second_category_id: goods.categoryId2,
        third_category_id: goods.categoryId3,
        first_category: goods.categoryName1,
        second_category: goods.categoryName2,
        third_category: goods.categoryName3,
        shop_id: goods.shopId,
        shop_name: goods.shopName,
      }
      $HMD$.aYiGuan('search_result_click', null, params)
    },
    yiGuanGoodsClick(btnName) {
      $HMD$.aYiGuan('btn_click', null, {
        $url: window.location.href,
        $url_domain: window.location.origin + window.location.pathname,
        $title: document.title,
        btn_name: btnName,
        desc: '搜索列表页',
        link_page_url: `${$HMD$.rApi.M}/Mall/Detail?p=${this.showPopId}`,
        content_type: '商品',
        content_id: this.showPopId,
        content: '商品',
        platform:$HMD$.rNavigator
      })
    },
    yiGuanSearch(type, num) {
      var filterDetail = vm.filterDetail || ''
      let data = {
        $referrer: document.referrer,
        content_type: '商品',
        $search_keyword: vm.filterObj.keyword,
        keyword_type: '其他',
        is_filter: filterDetail ? true : false,
        filter_detail: filterDetail,
        platform:$HMD$.rNavigator
      }
      if (num) {
        data.recommend_item_num = num
      }
      $HMD$.aYiGuan(type, null, data)
    },

    addToCard(goods, index) {
      //仅支持自营商品加单
      if (goods.productSource == 1) {
        vm.countClickGoods(goods, index, true)
        addShopCart({
          shopCartAddList: [
            {
              count: goods.orderMinCount,
              productId: goods.lowestPid,
              promotionId: goods.promotionId[0] || '',
            },
          ],
        }).then((res) => {
          const { data, respCode, respDesc } = res.data
          if (respCode == '0000') {
            debugger
            $HMD$.Prop('已加入进货单')
            if (data != null && data.deviceId != '') {
              $HMD$.Cookie({ type: 'set', name: 'deviceId', value: data.deviceId, domain: '.homedo.com' })
            }
          } else {
            $HMD$.Prop(respDesc)
          }
        })
      }
    },

    //判断是否尊享馆
    getZXdata(){
        let vm = this
        var cmsId = $HMD$.rApi.ENV == 'fat'? 375 : 251
        $.ajax({
            type: 'get',
            url: $HMD$.rApi.Cms + '/framework-cms-restws/json/' + cmsId,
            success:function(res){
               
                if(res.respCode === '0000' && res.data){
                    vm.zunxiangData = res.data
                    vm._getSearchFilterButton(vm.zunxiangData)
                }                
            }
        })       
    },
    _getSearchFilterButton(data,){
        let parmes={
            activeTags:data.activeTags,
            hippoSelectPromotionIds:data.hippoSelectPromotionIds,
            hippoSelectTags:data.hippoSelectTags,
            promotionIds:data.promotionIds,
            vipActiveTags:data.vipActiveTags,
            vipPromotionIds:data.vipPromotionIds,
            isScreen: data.isScreen,
        }
        getSearchFilterButton(parmes).then((res) => {
          if (res.data.respCode == '0000' && res.data.data) {
            // this.isZunXiang = res.data.data.isShow
            this.filterButtondata = res.data.data
          }
        })
    }
  },
}
</script>
<style>
html,
body {
  height: 100%;
}
</style>
<style lang="less" scoped>
@import '../../../assets/style/theme.less';
.goods-box {
  position: relative;
  .goods-detail {
    background: #fff;
    padding: 0.5rem 0.3rem;
    box-sizing: border-box;
    .goods-img {
      position: relative;
      .vipTag{
        position: absolute;
        top: 0;
        width: 5rem;
        height: 2rem;      
        background: url(//image01.homedo.com/Files/Images/cms/www/20230210/5005210074151804110_pic1.png) 0 0 no-repeat;
        background-size: 100%;
      }
      img.goods-default {
        border: 2px solid;
        border-image: linear-gradient(180deg, #001EFF, #00DBFF, #5B31E7) 2 2;
      }
      img.goods-seven {
        position: absolute;
        top: 0;
        left: 0;
        width: 5.2rem !important;
        height: 1.7rem !important;
      }
      img.goods-pre {
        position: absolute;
        bottom: 0;
        width: 4.5rem;
        height: 1.6rem;
        right: 0;
      }
      img.goods-active {
        position: absolute;
        top: 0;
        left: 0;
      }
      .is-ad {
        position: absolute;
        color: #cacaca;
        height: 1.4rem;
        bottom: 0;
        right: 1.2rem;
        font-size: 1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
      }
      .text-swiper {
        position: absolute;
        color: #cacaca;
        height: 1.4rem;
        width: 90%;
        bottom: 0;
        left: 1.2rem;
        font-size: 1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        overflow: hidden;
        margin: auto;
      }
    }
    .goods-content {
      flex: 1;
      .goods-title {
        color: #1e1f22;
        font-size: 1.4rem;
        line-height: 2rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .buy-title {
        color: #7d7f88;
      }
      .goods-shop {
        color: #7d7f88;
        font-size: 1.2rem;
        height: 1.5rem;
        line-height: 1.5rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: bold;
        display: flex;
        margin-top: 0.6rem;
        overflow: hidden;
        .img-icon {
          width: 1.5rem;
          height: 1.5rem;
          margin-right: 0.2rem;
          background: url(//image01.homedo.com/Files/Images/cms/www/20210915/4735164292920718601_pic1.png) 0 0 no-repeat;
          background-size: 1.5rem 1.5rem;
        }
      }
      .proper-type {
        margin: 0.6rem 0 0;
        height: 1.5rem;
        overflow: hidden;
        display: flex;
        flex-wrap: wrap;
        .proper-item {
          height: 1.5rem;
          line-height: 1.3rem;
          border-radius: 0.2rem;
          background: @hmd-bg-color;
          font-size: 1rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #7d7f88;
          border: 1px solid @hmd-bg-color;
          padding: 0 0.3rem;
          margin-right: 0.4rem;
          text-align: center;
          box-sizing: border-box;
        }
      }
      .tag-list {
        display: flex;
        height: 1.5rem;
        margin: 0.6rem 0 0;
        .tag-content {
          display: flex;
          flex-wrap: wrap;
          overflow: hidden;
        }
        .tag-item {
          height: 1.5rem;
          line-height: 1.3rem;
          border-radius: 0.2rem;
          border: 1px solid rgba(47, 123, 255, 0.4);
          font-size: 1rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2f7bff;
          text-align: center;
          padding: 0 0.3rem;
          margin-right: 0.4rem;
          box-sizing: border-box;
        }
        .zy {
          background: linear-gradient(90deg, #00d7ff 0%, #2f7bff 100%);
          color: #fff;
          padding-top: 0.1rem;
          border: none;
        }
      }
      .goods-price {
        color: #e52b2b;
        font-size: 1.8rem;
        font-weight: 500;
        display: flex;
        justify-content: space-between;
        margin-top: 0.6rem;
        height: 2rem;
        padding-bottom: 0.1rem;
        overflow: hidden;
        .price-icon {
          font-size: 1rem;
          font-weight: normal;
        }
        .shopping-card {
          display: inline-block;
          width: 1.8rem;
          height: 1.8rem;
          background: url(//image01.homedo.com/Files/Images/cms/www/20170809/5597357548186435810_pic1.png) no-repeat;
          background-size: 100%;
        }
      }
      .goods-sale {
        height: 2.5rem;
        padding-top: 0.6rem;
        display: flex;
        box-sizing: border-box;
        justify-content: space-between;
        .goods-num {
          color: #7d7f88;
          font-size: 1.2rem;
          margin-right: 0.8rem;
          display: inline-block;
        }
        .shopping-card {
          display: inline-block;
          width: 1.8rem;
          height: 1.8rem;
          background: url(//image01.homedo.com/Files/Images/cms/www/20170809/5597357548186435810_pic1.png) no-repeat;
          background-size: 100%;
        }
      }
    }
  }
}
.goods-pop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0 2rem;
  box-sizing: border-box;
  .pop-icon {
    display: block;
    width: 2.4rem;
    height: 2.4rem;
    margin: 0.6rem auto 0.6rem;
    background: url(//image01.homedo.com/Files/Images/cms/www/20210916/5054275947659610138_pic1.png) 0 0 no-repeat;
    background-size: 9.6rem 2.4rem;
  }
  .attention {
    background: #fe9c0b;
    .pop-icon {
      background-position: 0 0;
    }
  }
  .bargain {
    background: #f35050;
    .pop-icon {
      background-position: -2.4rem 0;
    }
    .similar {
      background: #2f7bff;
      .pop-icon {
        background-position: -4.8rem 0;
      }
    }
  }
}
.goods-pop > div {
  width: 6rem;
  height: 6rem;
  border-radius: 0.2rem;
  color: #fff;
  text-align: center;
}

.goods-list {
  .goods-box {
    .goods-detail {
      display: flex;
      border-bottom: 1px solid #eee;
      padding: 1.2rem 1.6rem;
      .goods-img {
        img {
          width: 9rem;
          height: 9rem;
        }
        // img:nth-child(1){
        //   border: 2px solid #0053FF;
        // }
        .is-ad {
          top: 8rem;
          right: 0;
        }
        .text-swiper {
          left: 0;
        }
      }
      .goods-content {
        margin-left: 1.6rem;
      }
    }
  }
}
.goods-grid {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  overflow: hidden;
  width: 100%;
  .goods-box {
    width: 50%;
    padding: 0.3rem;
    box-sizing: border-box;
    .goods-detail {
      // border: 2px solid #0053FF;
      height: 100%;
      .goods-img {
        .vipTag{
            width: 7rem;           
            background: url(//image01.homedo.com/Files/Images/cms/www/20230210/5078981303698601075_pic1.png) 0 0 no-repeat;
            background-size: 100%;
       
        }
        img {
          width: 12.8rem;
          height: 12.8rem;
          margin: 0 auto;
          display: block;
        }
        img.goods-active {
          top: -0.5rem;
          left: -0.3rem;
        }
      }
      .goods-content {
        padding: 0 1.2rem;
        margin-top: 0.8rem;
        .grid-hidden {
          display: none;
        }
      }
    }
  }
  .goods-pop {
    flex-direction: column;
    padding: 2rem 0;
    .pop-icon {
      margin: auto 0.6rem;
    }
  }
  .goods-pop > div {
    width: 13.2rem;
    height: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.fullscreen {
  position: fixed;
  z-index: 9999 !important;
}
</style>
